"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _renderTemplate = require("./renderTemplate");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Prep Templates
 *
 * Similarly to the merge constants function, this searches through the string constants
 * tree to find different types of templates.
 *
 * When it finds a string, array, or object, that it recognizes, it will then wrap it in
 * the renderTemplate function to prepare it to be rendered on a view.
 */
var prepTemplates = function prepTemplates(stringFile) {
  return Object.keys(stringFile).reduce(function (newSlice, stringFileKey) {
    var value = stringFile[stringFileKey];
    /** This is the most common value of value, so ideally we hit it and move on */

    if (typeof value === 'string' || (0, _lodash.isArray)(value)) {
      return _objectSpread(_objectSpread({}, newSlice), {}, _defineProperty({}, stringFileKey, (0, _renderTemplate.renderTemplate)(value)));
    }

    if ((0, _lodash.isPlainObject)(value)) {
      /* If we don't see a 'template' value on an object, keep searching down the tree */
      if (!Object.prototype.hasOwnProperty.call(value, 'template')) {
        return _objectSpread(_objectSpread({}, newSlice), {}, _defineProperty({}, stringFileKey, prepTemplates(value)));
      }

      return _objectSpread(_objectSpread({}, newSlice), {}, _defineProperty({}, stringFileKey, (0, _renderTemplate.renderTemplate)(value)));
    }

    return _objectSpread(_objectSpread({}, newSlice), {}, _defineProperty({}, stringFileKey, value));
  }, {});
};

var _default = prepTemplates;
exports.default = _default;